import { useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"

const initialLoginForm = {
  email: "",
  password: ""
}

function LogInForm({ setUser }) {
  const [ loginForm, setLoginForm ] = useState(initialLoginForm)
  const navigate = useNavigate()

  const handleLoginChange = e => {
    setLoginForm({
      ...loginForm,
      [e.target.name]: e.target.value
    })
  }

  const handleLoginSubmit = e => {
    e.preventDefault()
    loginForm.email = loginForm.email.toLowerCase()
    
    axios.post("https://roma-be.herokuapp.com/api/auth/login", loginForm)
      .then(res => {
        setUser(res)
        localStorage.setItem("token", res.data.token)
        navigate("/order/dining")
      })
  }

  return (
    <div className="log-in-container">
      <h1 className="register-h1">Log In</h1>

      <form onSubmit={handleLoginSubmit} className="sign-up-form">
        <input 
          className="sign-up-form-input"
          type="text" 
          name="email" 
          placeholder="Email" 
          onChange={handleLoginChange} 
          value={loginForm.email} />
        <input 
          className="sign-up-form-input"
          type="password" 
          name="password" 
          placeholder="Password" 
          onChange={handleLoginChange} 
          value={loginForm.password} />
        
        <button className="sign-up-submit-button">Submit</button>
        <span className="forgot-button" onClick={() => navigate("/forgot")}>Forgot your password?</span>
      </form>
    </div>
  )
}

export default LogInForm
